import axios from "./axiosInstance";

export default {
  // Create an agent
  createAgent(agentData) {
    return axios.post("/agents/", agentData);
  },

  // Get all agents
  getAgents(params) {
    const formattedParams = new URLSearchParams();
    for (const key in params) {
      if (Array.isArray(params[key])) {
        params[key].forEach((value) => {
          formattedParams.append(key, value);
        });
      } else {
        formattedParams.append(key, params[key]);
      }
    }
    return axios.get(
      `/agents/?${formattedParams.toString().replace(/,/g, "&project_ids=")}`
    );
  },

  // Get agent by ID
  getAgentById(agentId) {
    return axios.get(`/agents/${agentId}`);
  },

  // Delete an agent by ID
  deleteAgent(agentId) {
    return axios.delete(`/agents/${agentId}`);
  },

  // Update an agent by ID
  updateAgent(agentId, agentData) {
    return axios.patch(`/agents/${agentId}`, agentData);
  },

  // Search agents
  searchAgents(params) {
    const formattedParams = new URLSearchParams();
    for (const key in params) {
      if (Array.isArray(params[key])) {
        params[key].forEach((value) => {
          formattedParams.append(key, value);
        });
      } else {
        formattedParams.append(key, params[key]);
      }
    }
    return axios.get(
      `/agents/search?${formattedParams
        .toString()
        .replace(/,/g, "&project_ids=")}`
    );
  },

  getAvailableModels() {
    return axios.get("/agents/available_models");
  },
};
